/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
 
  ADD_FOLLOWUP,
  ADD_FOLLOWUP_SUCCESS,
  ADD_FOLLOWUP_ERROR,

  UPDATE_FOLLOWUP,
  UPDATE_FOLLOWUP_SUCCESS,
  UPDATE_FOLLOWUP_ERROR,
  
  LOAD_FOLLOWUP_LIST,
  LOAD_FOLLOWUP_LIST_SUCCESS,
  LOAD_FOLLOWUP_LIST_ERROR,

  LOAD_CHECK_LIST,
  LOAD_CHECK_LIST_SUCCESS,
  LOAD_CHECK_LIST_ERROR,

  LOAD_TEAM_SCHEDULE,
  LOAD_TEAM_SCHEDULE_SUCCESS,
  LOAD_TEAM_SCHEDULE_ERROR,

  LOAD_EC_FOLLOWUP_LIST,
  LOAD_EC_FOLLOWUP_LIST_SUCCESS,
  LOAD_EC_FOLLOWUP_LIST_ERROR,

  LOAD_EC_APP,
  LOAD_EC_APP_SUCCESS,
  LOAD_EC_APP_ERROR,

  LOAD_EC_EVENT,
  LOAD_EC_EVENT_SUCCESS,
  LOAD_EC_EVENT_ERROR,

  LOAD_DELIVERABLES,
  LOAD_DELIVERABLES_SUCCESS,
  LOAD_DELIVERABLES_ERROR,
  
  LOAD_DELIVER_META_DATA,
  LOAD_DELIVER_META_DATA_SUCCESS,
  LOAD_DELIVER_META_DATA_ERROR,

  LOAD_DELIVERABLE_STATUS,
  LOAD_DELIVERABLE_STATUS_SUCCESS,
  LOAD_DELIVERABLE_STATUS_ERROR,

  LOAD_CALL_CRITERIA,
  LOAD_CALL_CRITERIA_SUCCESS,
  LOAD_CALL_CRITERIA_ERROR,

  LOAD_CALL_ACTIONS,
  LOAD_CALL_ACTIONS_SUCCESS,
  LOAD_CALL_ACTIONS_ERROR,

  LOAD_DELIVERABLE_TAG,
  LOAD_DELIVERABLE_TAG_SUCCESS,
  LOAD_DELIVERABLE_TAG_ERROR,

  LOAD_ISSUES,
  LOAD_ISSUES_SUCCESS,
  LOAD_ISSUES_ERROR,

  ADD_ISSUES,
  ADD_ISSUES_SUCCESS,
  ADD_ISSUES_ERROR,

  UPDATE_ISSUES,
  UPDATE_ISSUES_SUCCESS,
  UPDATE_ISSUES_ERROR,

  DELETE_ISSUES,
  DELETE_ISSUES_SUCCESS,
  DELETE_ISSUES_ERROR,

  LOAD_CALL_RECORDING,
  LOAD_CALL_RECORDING_SUCCESS,
  LOAD_CALL_RECORDING_ERROR,
  //UPDATE_NOTES
  UPDATE_NOTES,
  UPDATE_NOTES_SUCCESS,
  UPDATE_NOTES_ERROR,

  LOAD_REVIEW,
  LOAD_REVIEW_SUCCESS,
  LOAD_REVIEW_ERROR,
  

  UPDATE_REVIEW,
  UPDATE_REVIEW_SUCCESS,
  UPDATE_REVIEW_ERROR,

  ADD_REVIEW,
  ADD_REVIEW_SUCCESS,
  ADD_REVIEW_ERROR

} from "./constants"

//Special Instructions
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}


export function loadOperationsFollowup(id) {
  return {
    type: LOAD_FOLLOWUP_LIST,
    id,
  }
}

export function loadOperationsFollowupSuccess(followup_list) {
  return {
    type: LOAD_FOLLOWUP_LIST_SUCCESS,
    followup_list,
  }
}



export function loadOperationsFollowupError(error) {
  return {
    type: LOAD_FOLLOWUP_LIST_ERROR,
    error,
  }
}

export function addOperationsFollowup(operationsFollowupData) {
  console.log("record", operationsFollowupData)
  return {
    type: ADD_FOLLOWUP,
    operationsFollowupData,
  }
}


export function addOperationsFollowupSuccess(operationsFollowupData, success) {

  return {
    type: ADD_FOLLOWUP_SUCCESS,
    operationsFollowupData,
    success,
  }
}


export function addOperationsFollowupError(error) {
  return {
    type: ADD_FOLLOWUP_ERROR,
    error,
  }
}

export function updateOperationsFollowup(updateFollowupData) {
  return {
    type: UPDATE_FOLLOWUP,
    updateFollowupData,
  }
}


export function updateOperationsFollowupSuccess(updateFollowupData, success) {
  return {
    type: UPDATE_FOLLOWUP_SUCCESS,
    updateFollowupData,
    success,
  }
}


export function updateOperationsFollowupError(error) {
  return {
    type: UPDATE_FOLLOWUP_ERROR,
    error,
  }
}

export function loadCheckList(id) {
  return {
    type: LOAD_CHECK_LIST,
    id,
  }
}

export function loadCheckListSuccess(check_list) {
  return {
    type: LOAD_CHECK_LIST_SUCCESS,
    check_list,
  }
}

export function loadCheckListError(error) {
  return {
    type: LOAD_CHECK_LIST_ERROR,
    error,
  }
}

export function loadTeamSchedule(id) {
  return {
    type: LOAD_TEAM_SCHEDULE,
    id,
  }
}

export function loadTeamScheduleSuccess(team_list) {
  return {
    type: LOAD_TEAM_SCHEDULE_SUCCESS,
    team_list,
  }
}

export function loadTeamScheduleError(error) {
  return {
    type: LOAD_TEAM_SCHEDULE_ERROR,
    error,
  }
}

export function loadEcFollowupList(id) {
  return {
    type: LOAD_EC_FOLLOWUP_LIST,
    id,
  }
}

export function loadEcFollowupListSuccess(ec_followup_list) {
  return {
    type: LOAD_EC_FOLLOWUP_LIST_SUCCESS,
    ec_followup_list,
  }
}



export function loadEcFollowupListError(error) {
  return {
    type: LOAD_EC_FOLLOWUP_LIST_ERROR,
    error,
  }
}

export function loadEcApp(id) {
  return {
    type: LOAD_EC_APP,
    id,
  }
}

export function loadEcAppSuccess(app_list) {
  return {
    type: LOAD_EC_APP_SUCCESS,
    app_list,
  }
}

export function loadEcAppError(error) {
  return {
    type: LOAD_EC_APP_ERROR,
    error,
  }
}

export function loadEcEvent(id) {
  return {
    type: LOAD_EC_EVENT,
    id,
  }
}

export function loadEcEventSuccess(event_list) {
  return {
    type: LOAD_EC_EVENT_SUCCESS,
    event_list,
  }
}

export function loadEcEventError(error) {
  return {
    type: LOAD_EC_EVENT_ERROR,
    error,
  }
}


export function loadDeliverables(id) {
  return {
    type: LOAD_DELIVERABLES,
    id,
  }
}

export function loadDeliverablesSuccess(deliver_list) {
  return {
    type: LOAD_DELIVERABLES_SUCCESS,
    deliver_list,
  }
}

export function loadDeliverablesError(error) {
  return {
    type: LOAD_DELIVERABLES_ERROR,
    error,
  }
}

export function loadDeliverMetaData() {
  return {
    type: LOAD_DELIVER_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadDeliverMetaDataSuccess(deliverMetaData) {
  return {
    type: LOAD_DELIVER_META_DATA_SUCCESS,
    deliverMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadDeliverMetaDataError(error) {
  return {
    type: LOAD_DELIVER_META_DATA_ERROR,
    error,
  }
}

export function loadDeliverableStatus(id) {
  return {
    type: LOAD_DELIVERABLE_STATUS,
    id,
  }
}

export function loadDeliverableStatusSuccess(deliverStatusData) {
  return {
    type: LOAD_DELIVERABLE_STATUS_SUCCESS,
    deliverStatusData,
  }
}


export function loadDeliverableStatusError(error) {
  return {
    type: LOAD_DELIVERABLE_STATUS_ERROR,
    error,
  }
}


//loadIssues

export function loadIssues(id) {
  return {
    type: LOAD_ISSUES,
    id,
  }
}

export function loadIssuesSuccess(issuesDetails) {
  return {
    type: LOAD_ISSUES_SUCCESS,
    issuesDetails,
  }
}


export function loadIssuesError(error) {
  return {
    type: LOAD_ISSUES_ERROR,
    error,
  }
}
//LOAD 
//loadCallCriteria
export function loadCallCriteria(id) {
  return {
    type: LOAD_CALL_CRITERIA,
    id,
  }
}

export function loadCallCriteriaSuccess(criteria_data) {
  return {
    type: LOAD_CALL_CRITERIA_SUCCESS,
    criteria_data,
  }
}


export function loadCallCriteriaError(error) {
  return {
    type: LOAD_CALL_CRITERIA_ERROR,
    error,
  }
}
//callActions
export function loadcallActions(id) {
  return {
    type: LOAD_CALL_ACTIONS,
    id,
  }
}

export function loadcallActionsSuccess(actions_data) {
  return {
    type: LOAD_CALL_ACTIONS_SUCCESS,
    actions_data,
  }
}


export function loadcallActionsError(error) {
  return {
    type: LOAD_CALL_ACTIONS_ERROR,
    error,
  }
}


export function loadDeliverableTag(id) {
  return {
    type: LOAD_DELIVERABLE_TAG,
    id,
  }
}

export function loadDeliverableTagSuccess(tagData) {
  return {
    type: LOAD_DELIVERABLE_TAG_SUCCESS,
      tagData,
  }
}


export function loadDeliverableTagError(error) {
  return {
    type: LOAD_DELIVERABLE_TAG_ERROR,
    error,
  }
}
//addIssues
export function addIssues(issueData) {
  return {
    type: ADD_ISSUES,
    issueData,
  }
}


export function addIssuesSuccess(success) {

  return {
    type: ADD_ISSUES_SUCCESS,
    success,
  }
}


export function addIssuesError(error) {
  return {
    type: ADD_ISSUES_ERROR,
    error,
  }
}
//updateIssues
export function updateIssues(issuesUpdate) {
  return {
    type: UPDATE_ISSUES,
    issuesUpdate,
  }
}


export function updateIssuesSuccess(success) {

  return {
    type: UPDATE_ISSUES_SUCCESS,
    success,
  }
}


export function updateIssuesError(error) {
  return {
    type: UPDATE_ISSUES_ERROR,
    error,
  }
}
//deleteIssues
export function deleteIssues(deleteIssues) {
  return {
    type:DELETE_ISSUES,
     deleteIssues,
  }
}


export function deleteIssuesSuccess(success) {

  return {
    type: DELETE_ISSUES_SUCCESS,
    success,
  }
}


export function deleteIssuesError(error) {
  return {
    type: DELETE_ISSUES_ERROR,
    error,
  }
}
//loadCallRecording
export function loadCallRecording(id) {
  return {
    type: LOAD_CALL_RECORDING,
    id,
  }
}

export function loadCallRecordingSuccess(call_Records) {
  return {
    type: LOAD_CALL_RECORDING_SUCCESS,
    call_Records,
  }
}


export function loadCallRecordingError(error) {
  return {
    type: LOAD_CALL_RECORDING_ERROR,
    error,
  }
}
//updateNotes
export function updateNotes(notes_data) {
  return {
    type: UPDATE_NOTES,
     notes_data,
  }
}


export function updateNotesSuccess(success) {

  return {
    type: UPDATE_NOTES_SUCCESS,
    success,
  }
}


export function updateNotesError(error) {
  return {
    type: UPDATE_NOTES_ERROR,
    error,
  }
}
//REVIEW
// loadReview
export function loadReview(id) {
  return {
    type: LOAD_REVIEW,
    id,
  }
}

export function loadReviewSuccess(review_List) {
  return {
    type: LOAD_REVIEW_SUCCESS,
     review_List,
  }
}


export function loadReviewError(error) {
  return {
    type: LOAD_REVIEW_ERROR,
    error,
  }
}
//addReview
 //ADD_REVIEW
export function addReview(reviewAdd_data) {
  return {
    type: ADD_REVIEW,
     reviewAdd_data,
  }
}
export function addReviewSuccess(success) {

  return {
    type: ADD_REVIEW_SUCCESS,
    success,
  }
}


export function addReviewError(error) {
  return {
    type: ADD_REVIEW_ERROR,
    error,
  }
}
//upadateReview
//updateNotes updateReview_data 
export function updateReview(updateReview_data) {
  return {
    type: UPDATE_REVIEW,
     updateReview_data,
  }
}


export function updateReviewSuccess(success) {

  return {
    type: UPDATE_REVIEW_SUCCESS,
    success,
  }
}


export function updateReviewError(error) {
  return {
    type: UPDATE_REVIEW_ERROR,
    error,
  }
}
const actions = {
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  addOperationsFollowup,
  addOperationsFollowupError,
  addOperationsFollowupSuccess,

  updateOperationsFollowupError,
  updateOperationsFollowup,
  updateOperationsFollowupSuccess,

  loadOperationsFollowup,
  loadOperationsFollowupSuccess,
  loadOperationsFollowupError,

  loadCheckList,
  loadCheckListSuccess,
  loadCheckListError,

  loadTeamSchedule,
  loadTeamScheduleSuccess,
  loadTeamScheduleError,

  loadEcFollowupList,
  loadEcFollowupListSuccess,
  loadEcFollowupListError,

  loadEcApp,
  loadEcAppSuccess,
  loadEcAppError,

  loadEcEvent,
  loadEcEventSuccess,
  loadEcEventError,

  loadDeliverables,
  loadDeliverablesSuccess,
  loadDeliverablesError,

  loadDeliverMetaData,
  loadDeliverMetaDataSuccess,
  loadDeliverMetaDataError,

  loadDeliverableStatus,
  loadDeliverableStatusSuccess,
  loadDeliverableStatusError,

  loadIssues,
  loadIssuesSuccess,
  loadIssuesError,

  loadCallCriteria,
  loadCallCriteriaSuccess,
  loadCallCriteriaError,

  loadDeliverableTag,
  loadDeliverableTagSuccess,
  loadDeliverableTagError,

  addIssues,
  addIssuesSuccess,
  addIssuesError,

  updateIssues,
  updateIssuesSuccess,
  updateIssuesError,

  loadCallRecording,
  loadCallRecordingSuccess,
  loadCallRecordingError,

  updateNotes,
  updateNotesSuccess,
  updateNotesError,

  loadReview,
  loadReviewSuccess,
  loadReviewError,

  addReview,
  addReviewSuccess,
  addReviewError,

  updateReview,
  updateReviewError,
  updateReviewSuccess,
}

export default actions
